import React from "react";
import { Helmet } from "react-helmet";
import { useSite } from "../theme/ThemeProvider";

const Seo = ({ title, description, path = "/", image, type = "website", jsonLd, noindex = false }) => {
  const site = useSite();
  const fullTitle = title ? `${title} | ${site.name}` : `${site.name} | LPG Dönüşüm, Bakım ve Araç Servisi – Yalova Altınova`;
  const url = `${site.url}${path}`;
  const img = image ? `${site.url}${image}` : `${site.url}/images/og-image.jpg`;
  return (
    <Helmet>
      <html lang="tr" />
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={site.name} />
      <meta property="og:locale" content="tr_TR" />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default Seo;

export function businessJsonLd(site) {
  return {
    "@context": "https://schema.org",
    "@type": "AutoRepair",
    name: site.name,
    url: site.url,
    telephone: site.phoneHref,
    email: site.email,
    image: `${site.url}/images/og-image.jpg`,
    description: `${site.name}: Yalova Altınova Kaytazdere'de LPG montaj, tank değişimi, LPG bakım, sızdırmazlık raporu, motor yağı değişimi ve çeki demiri montajı. 30 yıllık tecrübe.`,
    founder: { "@type": "Person", name: site.founder.name },
    address: {
      "@type": "PostalAddress",
      streetAddress: site.address.street,
      addressLocality: "Altınova",
      addressRegion: "Yalova",
      postalCode: site.address.postalCode,
      addressCountry: "TR",
    },
    areaServed: ["Yalova", "Altınova", "Kaytazdere", "Karamürsel", "Çiftlikköy", "Gölcük"],
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        opens: "09:00",
        closes: "18:00",
      },
    ],
    priceRange: "₺₺",
  };
}
